import React from "react";
var __jsx = React.createElement;
import SingleCityComponent from "@/pages/Cities/CityComponents/SingleCity/SingleCityComponent";
import Layout from "@/_LayoutsRelated/layout/Layout";
import { useFullPageData } from "@/common/Contexts/FullPageContext";
import { PageNamesEnum } from "@/routes/routes";
var SingleCityPage = function SingleCityPage() {
  var cityDetails = useFullPageData(PageNamesEnum.PAGE_NAME__SingleCity);
  if (!cityDetails) return null;
  return /*#__PURE__*/React.createElement(Layout, {
    headHideLinks: true,
    hasNavBar: true,
    authenticationMsg: true,
    mainClass: "",
    linksForSearch: true,
    hideOrangeHeadBtn: true,
    disableLoader: true,
    hideAppBanner: true,
    hasMobFooter: true,
    loading: true
  }, /*#__PURE__*/React.createElement(SingleCityComponent, {
    cityDetails: cityDetails,
    cityName: cityDetails === null || cityDetails === void 0 ? void 0 : cityDetails.city_name
  }));
};
export default SingleCityPage;